export default __webpack_public_path__ + "static/media/ip.bafd5a41.png";